const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'oraichain',
    assets: [{
            description: 'The native token of Oraichain',
            denom_units: [{
                    denom: 'orai',
                    exponent: 0
                }, {
                    denom: 'ORAI',
                    exponent: 6
                }],
            base: 'orai',
            name: 'Oraichain',
            display: 'ORAI',
            symbol: 'ORAI',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png'
            },
            coingecko_id: 'oraichain-token',
            images: [
                {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png',
                    theme: {
                        circle: true,
                        dark_mode: true,
                        primary_color_hex: '#040404'
                    }
                },
                {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.svg',
                    theme: {
                        circle: true,
                        dark_mode: true,
                        primary_color_hex: '#FFFFFF'
                    }
                },
                {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.svg',
                    theme: {
                        circle: true,
                        dark_mode: false,
                        primary_color_hex: '#000000'
                    }
                }
            ]
        }]
};
export default info;
